"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TouristsPickerMobileDropdown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _MobileDropdown = require("../../../MobileDropdown");
var _TouristsPickerMobile = require("../TouristsPickerMobile");
var _utils = require("../../utils");
var _constants = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:

// Interfaces:

// Utils:

// Constants:

var TouristsPickerMobileDropdown = exports.TouristsPickerMobileDropdown = function TouristsPickerMobileDropdown(props) {
  var adultsValue = props.adultsValue,
    _props$kidsValue = props.kidsValue,
    kidsValue = _props$kidsValue === void 0 ? [] : _props$kidsValue,
    _props$onChangeAdults = props.onChangeAdults,
    onChangeAdults = _props$onChangeAdults === void 0 ? function () {
      return undefined;
    } : _props$onChangeAdults,
    _props$onChangeKids = props.onChangeKids,
    onChangeKids = _props$onChangeKids === void 0 ? function () {
      return undefined;
    } : _props$onChangeKids,
    CustomControl = props.CustomControl,
    CustomLabel = props.CustomLabel,
    isMobileInput = props.isMobileInput,
    setBodyLocked = props.setBodyLocked,
    isWhiteLabel = props.isWhiteLabel;
  var _useState = (0, _react.useState)(adultsValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    initialAdults = _useState2[0];
  var _useState3 = (0, _react.useState)(kidsValue),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 1),
    initialKids = _useState4[0];

  /**
   * устанавливаем дефолтные параметры, если пользователь закрыл попап
   */
  var handleCancel = function handleCancel() {
    onChangeAdults(initialAdults);
    onChangeKids(initialKids);
    setBodyLocked === null || setBodyLocked === void 0 || setBodyLocked(false);
  };
  var onClick = function onClick() {
    setBodyLocked === null || setBodyLocked === void 0 || setBodyLocked(true);
  };
  var onSubmit = function onSubmit() {
    setBodyLocked === null || setBodyLocked === void 0 || setBodyLocked(false);
  };
  var defaultTouristsLabel = (0, _utils.getTouristsLabel)({
    adultsValue: adultsValue,
    kidsValue: kidsValue
  });
  var touristsLabel = CustomControl ? CustomLabel : defaultTouristsLabel;
  return /*#__PURE__*/_react["default"].createElement(_MobileDropdown.MobileDropdown, {
    popupLabel: _constants.popupLabel,
    dropdownLabel: touristsLabel,
    onCancel: handleCancel,
    onControlClick: onClick,
    onSubmit: onSubmit,
    withHeader: isMobileInput,
    isWhiteLabel: isWhiteLabel,
    containerStyles: containerStyles,
    CustomDropdownLabel: CustomControl
  }, /*#__PURE__*/_react["default"].createElement(_TouristsPickerMobile.TouristsPickerMobile, {
    onChangeAdults: onChangeAdults,
    onChangeKids: onChangeKids,
    adultsValue: adultsValue,
    kidsValue: kidsValue,
    isMobileInput: isMobileInput
  }));
};
var containerStyles = (0, _styledComponents.css)(["padding:0 8px;"]);